import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import employeesService from "../employeesService"

import { IPagination } from "types/shared"
export interface IEmployee {
  id: number
  box: number
  averageWashTime?: number
  fullName?: string
  personalCode?: string
  phoneNumber?: string
  roleId?: string
  roleName?: string
  startDate?: Date
  totalWashCount?: number
  carWashBoxCount?: number
  salaryPercent?: string
}

export interface IEmployeesRes extends IPagination {
  data: IEmployee[]
}

export interface IGetEmployeesQueryParams {
  sortBy: string
  pageSize: number
  pageIndex: number
  carWashIds: number[]
}

const useGetEmployees = (query: IGetEmployeesQueryParams, enabled: boolean) => {
  return useQuery(
    ["employees", { ...query }],
    async () => {
      try {
        const res: AxiosResponse<any> = await employeesService.getEmployees(
          query,
        )

        return res.data.data
      } catch (err: any) {
        return err.response
      }
    },
    { enabled, refetchOnMount: false, refetchOnWindowFocus: false },
  )
}

export default useGetEmployees
